export default __webpack_public_path__ + "static/media/NUOVAOFFICINAELOCALIACCESSORI.f1a2fdbf.pdf";